import React from 'react';
import { Box, Typography, Link } from '@mui/material';
import { styled } from '@mui/material/styles';
import { Link as RouterLink } from 'react-router-dom';

const FooterContainer = styled(Box)(({ theme }) => ({
  backgroundColor: 'rgba(11, 8, 19, 0.95)',
  borderTop: '1px solid #00F0FF',
  padding: '30px 40px',
  marginTop: '40px',
  position: 'relative',
  zIndex: 10,
  [theme.breakpoints.down('md')]: {
    padding: '20px 30px',
    marginTop: '30px',
  },
  [theme.breakpoints.down('sm')]: {
    padding: '15px 20px',
    marginTop: '20px',
  },
}));

const FooterContent = styled(Box)(({ theme }) => ({
  maxWidth: '1200px',
  margin: '0 auto',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  flexWrap: 'wrap',
  gap: '20px',
  [theme.breakpoints.down('md')]: {
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '15px',
  },
  [theme.breakpoints.down('sm')]: {
    gap: '10px',
  },
}));

const FooterSection = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '10px',
  [theme.breakpoints.down('sm')]: {
    gap: '8px',
  },
}));

const FooterLink = styled(Link)(({ theme }) => ({
  color: '#6B6A78',
  textDecoration: 'none',
  fontSize: '12px',
  fontFamily: '"JetBrains Mono", monospace',
  transition: 'all 0.3s ease',
  cursor: 'pointer',
  [theme.breakpoints.down('sm')]: {
    fontSize: '10px',
  },
  '&:hover': {
    color: '#00F0FF',
    textDecoration: 'underline',
  },
})) as typeof Link;

const Footer: React.FC = () => {
  return (
    <FooterContainer>
      <FooterContent>
        <FooterSection>
          <Typography sx={{
            fontSize: '14px',
            color: '#FFFFFF',
            fontFamily: '"Press Start 2P", cursive',
            marginBottom: '10px',
          }}>
            StegSafe
          </Typography>
          <Typography sx={{
            fontSize: '11px',
            color: '#6B6A78',
            fontFamily: '"JetBrains Mono", monospace',
            maxWidth: '400px',
          }}>
            Your images are processed locally and never stored. Privacy-first steganography tool.
          </Typography>
        </FooterSection>

        <FooterSection>
          <Typography sx={{
            fontSize: '12px',
            color: '#00F0FF',
            fontFamily: '"Press Start 2P", cursive',
            marginBottom: '10px',
          }}>
            RESOURCES
          </Typography>
          <FooterLink component={RouterLink} to="/how-it-works">How It Works</FooterLink>
          <FooterLink component={RouterLink} to="/about">About</FooterLink>
          <FooterLink component={RouterLink} to="/security">Security</FooterLink>
          <FooterLink component={RouterLink} to="/faq">FAQ</FooterLink>
        </FooterSection>

        <FooterSection>
          <Typography sx={{
            fontSize: '12px',
            color: '#00F0FF',
            fontFamily: '"Press Start 2P", cursive',
            marginBottom: '10px',
          }}>
            LEGAL
          </Typography>
          <FooterLink component={RouterLink} to="/privacy">Privacy Policy</FooterLink>
          <FooterLink component={RouterLink} to="/terms">Terms of Service</FooterLink>
        </FooterSection>

        <FooterSection>
          <Typography sx={{
            fontSize: '14px',
            color: '#00F0FF',
            fontFamily: '"Press Start 2P", cursive',
            textShadow: '0 0 10px rgba(0, 240, 255, 0.5)',
          }}>
            &copy; 2026 StegSafe by Rishi Patel. All rights reserved.
          </Typography>
        </FooterSection>
      </FooterContent>
    </FooterContainer>
  );
};

export default Footer;
